import { IRor, IRorResponseItem } from '@vivli/features/organizations/infrastructure/interface';
import { useRorHelpers } from './use-ror-helpers.hook';

export function useRorOrganizations() {
    const { getRorName } = useRorHelpers();
    const getRorInformationFromSelection = (selections: any, suggestedMatches: IRorResponseItem[], currentRor: IRor) => {
        const selectedString: string = selections;
        const selectedRor = suggestedMatches.find((r) => r.id === selectedString);
        if (selectedRor) {
            let newRorInfo: IRor = { ...currentRor };
            newRorInfo.rorId = selectedRor.id;
            newRorInfo.rorName = getRorName(selectedRor);
            if (selectedRor.relationships.find((r) => r.type.toLowerCase() === 'parent')) {
                newRorInfo.parentRorId = selectedRor.relationships.find((r) => r.type.toLowerCase() === 'parent').id;
                newRorInfo.parentRorName = selectedRor.relationships.find((r) => r.type.toLowerCase() === 'parent').label;
            } else {
                newRorInfo.parentRorId = null;
                newRorInfo.parentRorName = '';
            }
            return newRorInfo;
        }
        return null;
    };

    return {
        getRorInformationFromSelection,
    };
}
